import Vue from 'vue'

let paginate = new Vue({
  data () {
    return {
      currentPage: 1,
      maxButtons: 5,
      limInf: 0,
      limSup: 0,
      totalPages: 0,
      totalElements: 0,
      xPage: ''
    }
  },

  computed: {
    startPage () {
      return this.currentPage === 1 ? 1
        : this.currentPage === this.totalPages
          ? this.totalPages - this.maxButtons + 1
          : this.currentPage - 1
    },

    endPage () {
      return Math.min(this.startPage + this.maxButtons - 1, this.totalPages)
    },

    pages () {
      return this.setPages()
    }
  },

  watch: {
    totalPages () {
      this.maxButtons = 5
      if (this.totalPages > this.maxButtons) {
        this.maxButtons = 5
      } else {
        this.maxButtons = this.totalPages
      }
    }
  },

  methods: {
    decrement () {
      this.currentPage -= 1
      return this.currentPage
    },

    getCurrentPage () {
      return this.currentPage
    },

    getLimInf () {
      return this.limInf
    },

    getLimSup () {
      return this.limSup
    },

    getMaxButtons () {
      return this.maxButtons
    },

    getTotalElements () {
      return this.totalElements
    },

    getTotalPages () {
      return this.totalPages
    },

    getXpage () {
      return this.xPage
    },

    increment () {
      this.currentPage += 1
      return this.currentPage
    },

    initial () {
      this.currentPage = 1
      return this.currentPage
    },

    last () {
      this.currentPage = this.totalPages
      return this.currentPage
    },

    lengthPages () {
      return this.pages
    },

    setCurrentPage (value) {
      this.currentPage = value
    },

    setLimInf (cant) {
      if (cant === 0) {
        this.limInf = 0
      } else {
        this.limInf = ((this.currentPage - 1) * this.xPage) + 1
      }
    },

    setLimSup (cant) {
      if (cant === 0) {
        this.limSup = 0
      } else {
        this.limSup = cant * this.currentPage
      }
    },

    setMaxButtons (value) {
      this.maxButtons = value
    },

    setPages () {
      const range = []
      if (this.endPage === this.totalPages) {
        for (let i = this.endPage - this.maxButtons + 1; i <= this.endPage; i++) {
          range.push(i)
        }
      } else {
        for (let i = this.startPage; i <= this.endPage; i++) {
          range.push(i)
        }
      }
      return range
    },

    setTotalElements (value) {
      this.totalElements = value
    },

    setTotalPages (value) {
      this.totalPages = value
    },

    setXpage (value) {
      this.xPage = value
    }
  }
})
export default {
  install: (Vue) => {
    Vue.prototype.$paginate = paginate
  }
}
